import React from "react";
import { useVoice } from "../context/VoiceContext";

const IMG = "https://customer-assets.emergentagent.com/job_ai-agent-builder-135/artifacts/s8r4h7c5_%CE%A3%CF%84%CE%B9%CE%B3%CE%BC%CE%B9%CF%8C%CF%84%CF%85%CF%80%CE%BF%20%CE%BF%CE%B8%CF%8C%CE%BD%CE%B7%CF%82%202026-04-20%20214621.png";

/**
 * Animated GP photo that "breathes" and pulses while the Co-Pilot is speaking.
 * - Idle: subtle breathing scale + neon border breathe
 * - Speaking: scales with audio level + neon glow + waveform bars
 */
export default function TalkingHead({ size = 180, className = "" }) {
  const { speaking, level } = useVoice() || {};
  const intensity = speaking ? Math.max(0.2, level || 0) : 0;
  const scale = 1 + intensity * 0.07;
  const glow = speaking ? 30 + intensity * 50 : 14;

  return (
    <div className={`relative inline-block ${className}`} style={{ width: size, height: size }} data-testid="talking-head">
      {/* Neon ring */}
      <div
        className={`absolute inset-0 rounded-none border border-[color:var(--gio-primary)] pointer-events-none transition-[box-shadow] duration-75`}
        style={{
          boxShadow: `0 0 ${glow}px rgba(255,51,0,${speaking ? 0.45 + intensity * 0.4 : 0.2}), inset 0 0 ${glow / 2}px rgba(255,51,0,${speaking ? 0.25 : 0.08})`,
        }}
      />
      {/* Image */}
      <img
        src={IMG}
        alt="GP App"
        className={`w-full h-full object-cover transition-transform duration-75 ${speaking ? "" : "gio-breathe"}`}
        style={{ transform: `scale(${scale})`, transformOrigin: "center 30%" }}
        data-testid="talking-head-image"
      />
      {/* Mouth glow overlay when speaking */}
      {speaking && (
        <div
          className="absolute left-1/2 pointer-events-none"
          style={{
            bottom: "34%",
            width: `${30 + intensity * 25}%`,
            height: `${4 + intensity * 8}px`,
            transform: "translateX(-50%)",
            background: `radial-gradient(ellipse, rgba(255,51,0,${0.4 + intensity * 0.5}) 0%, transparent 70%)`,
            filter: "blur(4px)",
          }}
        />
      )}
      {/* Waveform bars */}
      {speaking && (
        <div className="absolute -bottom-8 left-0 right-0 flex items-end justify-center gap-[3px] h-6" data-testid="talking-head-waveform">
          {[0, 1, 2, 3, 4, 5, 6, 7, 8].map((i) => {
            const h = 4 + Math.abs(Math.sin((Date.now() / (60 + i * 12)) + i)) * intensity * 40 + intensity * 5;
            return (
              <span key={i} className="bg-[color:var(--gio-primary)] w-[3px]" style={{ height: `${h}px`, opacity: 0.7 + intensity * 0.3 }} />
            );
          })}
        </div>
      )}
      <style>{`
        @keyframes gio-breathe { 0%,100% { transform: scale(1); } 50% { transform: scale(1.015); } }
        .gio-breathe { animation: gio-breathe 4s ease-in-out infinite; }
      `}</style>
    </div>
  );
}
